import { AgreeCheckbox } from "@/js/components/AgreeCheckbox";
import { CustomFileInput } from "@/js/components/CustomFileInput";
import { DatetimePicker } from "@/js/components/DatetimePicker";
import { EnterpriseAccountMenu } from "@/js/components/EnterpriseAccountMenu";
import { ModalActionComplete } from "@/js/components/ModalActionComplete";
import { NestedLink } from "@/js/components/NestedLink";
import { formSubmitSingle } from "./helpers/formSubmitSingle";

AgreeCheckbox.attach();
CustomFileInput.attach();
DatetimePicker.attach();
EnterpriseAccountMenu.attach();
ModalActionComplete.attach();
NestedLink.attach();
formSubmitSingle();
